import { useState, useCallback, useRef, useEffect } from 'react';

const useDebounceCallback = (callback, wait = 100, leading = false) => {
  // eslint-disable-next-line no-void
  const timeout = useRef(void 0);
  // Cleans up pending timeouts when the deps change
  useEffect(() => () => {
    clearTimeout(timeout.current);
    // eslint-disable-next-line no-void
    timeout.current = void 0;
  }, [callback, wait, leading]);

  // eslint-disable-next-line func-names
  return useCallback(
  // eslint-disable-next-line consistent-return
  function () {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const {
      current
    } = timeout;
    // Calls on leading edge
    // eslint-disable-next-line no-void
    if (current === void 0 && leading) {
      timeout.current = setTimeout(() => {
        // eslint-disable-next-line no-void
        timeout.current = void 0;
      }, wait);
      // eslint-disable-next-line prefer-spread
      return callback.apply(null, args);
    }
    // Clear the timeout every call and start waiting again
    clearTimeout(current);
    // Waits for `wait` before invoking the callback
    timeout.current = setTimeout(() => {
      // eslint-disable-next-line no-void
      timeout.current = void 0;
      // eslint-disable-next-line prefer-spread
      callback.apply(null, args);
    }, wait);
  }, [callback, wait, leading]);
};
function useDebounce(initialState, wait, leading) {
  const [state, setState] = useState(initialState);
  return [state, useDebounceCallback(setState, wait, leading)];
}

export default useDebounce;
